// Hàm xử lý nội dung để chuyển đổi URL YouTube thành iframe với youtube-nocookie
export const processContentForYouTube = (content: string): string => {
  // Pattern để tìm URL YouTube trong nội dung
  const youtubePatterns = [
    /(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([a-zA-Z0-9_-]+)/g,
    /(?:https?:\/\/)?youtu\.be\/([a-zA-Z0-9_-]+)/g
  ];

  let processedContent = content;

  // Xử lý từng pattern - sử dụng youtube-nocookie.com để tránh lỗi CORS
  youtubePatterns.forEach(pattern => {
    processedContent = processedContent.replace(pattern, (match, videoId) => {
      // Sử dụng youtube-nocookie.com thay vì youtube.com để tránh lỗi kết nối
      return `<iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/${videoId}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;
    });
  });

  return processedContent;
};

// Hàm xử lý URL YouTube đơn lẻ
export const convertYouTubeUrl = (url: string): string => {
  const patterns = [
    /(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([a-zA-Z0-9_-]+)/,
    /(?:https?:\/\/)?youtu\.be\/([a-zA-Z0-9_-]+)/
  ];

  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match && match[1]) {
      return `<iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/${match[1]}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;
    }
  }

  return url; // Trả về URL gốc nếu không phải YouTube
};

// Hàm kiểm tra xem URL có phải YouTube không
export const isYouTubeUrl = (url: string): boolean => {
  const patterns = [
    /(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([a-zA-Z0-9_-]+)/,
    /(?:https?:\/\/)?youtu\.be\/([a-zA-Z0-9_-]+)/
  ];

  return patterns.some(pattern => pattern.test(url));
};

// Hàm lấy video ID từ URL YouTube
export const getYouTubeVideoId = (url: string): string | null => {
  const patterns = [
    /(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([a-zA-Z0-9_-]+)/,
    /(?:https?:\/\/)?youtu\.be\/([a-zA-Z0-9_-]+)/
  ];

  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match && match[1]) {
      return match[1];
    }
  }

  return null;
};

// Hàm làm sạch nội dung - GIỮ NGUYÊN iframe YouTube
export const cleanYouTubeHTML = (content: string): string => {
  return content;
};